import withCheckoutContext from '@/withCheckoutContext';
import { default as MetaFlowProviderComponent } from '@/clientState/providers/MetaFlowProvider';

export default withCheckoutContext(MetaFlowProviderComponent);
